import styled from 'styled-components';

export const DateDashboard = styled.div.attrs({
    role: 'date-dashboard'
})`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    
    white-space: nowrap;
    cursor: pointer;

    font-size: 16px;
    font-weight: bold;

    color: white;

    @media screen and (max-width: 1024px) {
        margin-left: 0;
    }

    @media screen and (max-width: 955px) {
        width: 35px;
        overflow: hidden;
        justify-content: flex-start;
    }
`;

export const DateContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 20px;

    span{
        font-size: 10px;
        text-decoration: underline;
    }
    
    p{
        color: #ffffff;
        font-size: 16px !important;
        line-height: 0;
        overflow: inherit;
    }
    
    @media screen and (max-width: 1024px) {
        justify-content: flex-start;
        margin-left: 10px;
    }
`;